import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ServiceResponse } from '../models/responses/service-response';
import { environment } from '../environments/environments';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ServiceService {

  constructor(private httpClient: HttpClient) { }

  createServices(services: ServiceResponse[]): Observable<ServiceResponse[]> {
    return this.httpClient.post<ServiceResponse[]>(`${environment.serviceUrl}/create`, { services });
  }

  updateServices(services: ServiceResponse[]): Observable<ServiceResponse[]> {
    return this.httpClient.put<ServiceResponse[]>(`${environment.serviceUrl}/update`, { services });
  }

  removeService(id: number): Observable<ServiceResponse[]> {
    return this.httpClient.delete<ServiceResponse[]>(`${environment.serviceUrl}/remove/${id}`);
  }
}
